import { axiosBase, axiosCustom } from '@/plugins/axios'

export class User {
  updateToken(renewtoken) {
    return axiosCustom
      .post('/v1/users/renewtoken', { renew_token: renewtoken })
      .then((response) => response.data)
  }

  impersonateUser(userId) {
    return axiosCustom.post(`/v3/users/${userId}/token`).then((response) => response.data)
  }

  getCurrentUserInfo() {
    return axiosCustom.get('/v1/users/info').then((response) => response.data)
  }

  getServiceMessage() {
    return axiosCustom.get('/v2/projects/maintance').then((response) => response.data)
  }

  setServiceMessage(data) {
    return axiosCustom.post('/v2/projects/maintance', data).then((response) => response.data)
  }

  getAgreementNotice() {
    return axiosCustom.get('/v2/projects/agreement-notice').then((response) => response.data)
  }

  setAgreementNotice(data) {
    return axiosCustom.post('/v2/projects/agreement-notice', data).then((response) => response.data)
  }

  confirmAgreement() {
    return axiosCustom.get('/v1/users/confirm-agreement').then((response) => response.data)
  }

  registerUser(form) {
    return axiosBase.post('/v3/users/register', form).then((response) => response.data)
  }

  getAcp() {
    return axiosCustom.get('/v2/projects/acp').then((response) => response.data)
  }

  setAcp(data) {
    return axiosCustom.post('/v2/projects/acp', data).then((response) => response.data)
  }

  getUserInfoById(userId) {
    return axiosCustom.get(`/v1/users/${userId}`).then((response) => response.data)
  }

  updateInfoByUser(userId, form) {
    return axiosCustom.patch(`/v1/users/${userId}/update`, form).then((response) => response.data)
  }

  setGroupToUser(form) {
    return axiosCustom.post('/v1/users/setgroups', form).then((response) => response.data)
  }

  getUsers(filters) {
    const params = new URLSearchParams({
      ...filters,
    }).toString()

    return axiosCustom.get(`/v1/users?${params}`).then((response) => response.data)
  }

  getUsersByGroup(group, page = 1) {
    const params = new URLSearchParams({
      id: group,
      pageSize: 20,
      page,
    }).toString()

    return axiosCustom.get(`/v1/user?${params}`).then((response) => response.data)
  }
}
